export class SearchCriteriaModel {
    public criteria = ''; // default empty string so we don't have to it to '' every time
}
